import React from 'react';
import cx from 'classnames';
// components
import { BlockHeader } from '@ems/client-design-system';
import { InfringementMapContainer } from './';
// utils
import { formatFromISO } from 'src/utils/dateTimeConverters';
// constants
import { CORRIDOR_INFRINGEMENT, EXCLUSION_INFRINGEMENT, GATE_INFRINGEMENT } from 'src/constants';

export const InfringementRuleContainer = ({
  title,
  time,
  operationId,
  operation,
  selectionOnMap,
  infringementType,
  infringementId,
  position,
  extraIds,
}) => {
  let infTypeId;
  const { corridorId, selectionZoneId, gateId } = selectionOnMap;
  switch (infringementType) {
    case CORRIDOR_INFRINGEMENT:
      infTypeId = corridorId;
      break;
    case EXCLUSION_INFRINGEMENT:
      infTypeId = selectionZoneId;
      break;
    case GATE_INFRINGEMENT:
      infTypeId = gateId;
      break;
    default:
  }
  return (
    <div className={cx({ 'no-pad-bottom': infringementType === GATE_INFRINGEMENT })}>
      <BlockHeader
        title={title}
        cta={
          time && <span className="infringements_time">{formatFromISO(time, 'HH:mm, DDD')}</span>
        }
      />
      <InfringementMapContainer
        operationId={operationId}
        operation={operation}
        infTypeId={infTypeId}
        time={time}
        infringementType={infringementType}
        infringementId={infringementId}
        position={position}
        extraIds={extraIds}
      />
    </div>
  );
};
